import {useState, useEffect} from 'react'
import axios from 'axios'
import PendingApplications from '../../components/Admin/Applications/PendingApplications'
import InProcessApplications from '../../components/Admin/Applications/InProcessApplications'
import AcceptedApplications from '../../components/Admin/Applications/AcceptedApplications'
import RejectedApplications from '../../components/Admin/Applications/RejectedApplications'

const Applications = () => {
    const [activeTab, setActiveTab] = useState("New Applications");
    const [consultants, setConsultants] = useState([]);
    const [applicationData, setApplicationData] = useState({
        pending: [],
        inProcess: [],
        accepted: [],
        rejected: [],
    });

    // Helper to format date as dd-mm-yy
    const formatDate = (isoString) => {
        if (!isoString) return ""; // or "N/A"
        const dateObj = new Date(isoString);
        if (isNaN(dateObj)) return "";

        const day = String(dateObj.getDate()).padStart(2, "0");
        const month = String(dateObj.getMonth() + 1).padStart(2, "0");
        const year = dateObj.getFullYear().toString().slice(-2);
        return `${day}/${month}/${year}`;
    };

    const fetchApplications = async () => {
        const token = localStorage.getItem("token");
        if (!token) {
            // console.error("Token not found");
            return;
        }

        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/application/status`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });

            const data = response.data?.data || {};
            setApplicationData({
                pending: data.pending || [],
                inProcess: data.inProcess || [],
                accepted: data.accepted || [],
                rejected: data.rejected || [],
            });
        } catch (error) {
            // console.error('Error fetching consultations:', error);
        }
    };

    const fetchConsultants = async () => {
        try {
            const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/consultant/all`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem("token")}`,
                }
            });
            setConsultants(response.data.data || []);


        } catch (error) {
            // console.error('Error fetching consultants:', error);
        }
    };

    useEffect(() => {
        fetchApplications();
        fetchConsultants();
    }, []);
    useEffect(() => {
        // console.log("applications Data", applicationData)
        
    }, [applicationData]);


    const renderContent = () => {
        switch (activeTab) {
            case "New Applications":
                return <PendingApplications applications={applicationData.pending} formatDate={formatDate} consultants={consultants} fetchConsultants={fetchConsultants} fetchApplications={fetchApplications} />;
            case "In Process":
                return <InProcessApplications applications={applicationData.inProcess} formatDate={formatDate} consultants={consultants} fetchConsultants={fetchConsultants} fetchApplications={fetchApplications} />;
            case "Accepted":
                return <AcceptedApplications applications={applicationData.accepted} formatDate={formatDate} fetchConsultants={fetchConsultants} fetchApplications={fetchApplications} />;
            case "Rejected":
                return <RejectedApplications applications={applicationData.rejected} formatDate={formatDate} fetchConsultants={fetchConsultants} fetchApplications={fetchApplications} />;
            default:
                return <PendingApplications applications={applicationData.pending} formatDate={formatDate} consultants={consultants} fetchConsultants={fetchConsultants} fetchApplications={fetchApplications} />;
        }
    };

    return (
        <div className="relative pl-36 pr-12 mt-16 w-full py-8 min-h-screen">
            <div className="px-10 py-6 bg-white rounded shadow-md">
                <div className="flex mb-4 w-full border-b">
                    {['New Applications', 'In Process', 'Accepted', 'Rejected'].map((tab) => (
                        <button
                            key={tab}
                            className={`px-4 py-2 text-lg font-semibold flex-1 text-center ${activeTab === tab ? "text-blue-500 border-b-2 border-blue-500" : "text-gray-600"}`}
                            onClick={() => setActiveTab(tab)}
                        >
                            {tab}
                        </button>
                    ))}
                </div>
                {renderContent()}
            </div>
        </div>
    );
}

export default Applications